import {
  Button,
  Card, CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Input,
  InputLabel,
  Select,
  Table, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import SaveIcon from '@material-ui/icons/Save';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import SondajPhoto from './SondajPhoto.js';
import logger from 'src/utils/logger';

//= getUser();

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430,
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  formControl: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
}));





function CentralPaperDetail({ className, items, tarihce, Loading, handleRefreshSondaj }) {



  const classes = useStyles();
  const [KaynakValue, setKaynakValue] = React.useState();
  const [KaynakOptions, setKaynakOptions] = React.useState({});
  const [KonuValue, setKonuValue] = React.useState(null);
  const [KonuOptions, setKonuOptions] = React.useState({});
  const [DurumValue, setDurumValue] = React.useState(null);
  const [DurumOptions, setDurumOptions] = React.useState({});
  const [SonucValue, setSonucValue] = React.useState(null);
  const [SonucOptions, setSonucOptions] = React.useState({});
  const [TarihceData, setTarihceData] = React.useState([]);
  const [, setTurValue] = React.useState({});
  const [TurOptions, setTurOptions] = React.useState({});
  const [TarihValue, setTarihValue] = React.useState(null);
  const [AciklamaValue, setAciklamaValue] = React.useState(null);
  const [GAR_MLZValue, setGAR_MLZValue] = React.useState(null);
  const [GAR_ISCValue, setGAR_ISCValue] = React.useState(null);
  const [MON_MLZValue, setMON_MLZValue] = React.useState(null);
  const [MON_ISCValue, setMON_ISCValue] = React.useState(null);
  const [HURDAValue, setHURDAValue] = React.useState(null);
  const [CEZAValue, setCEZAValue] = React.useState(null);
  const [NAKLIYEValue, setNAKLIYEValue] = React.useState(null);
  const [YOLValue, setYOLValue] = React.useState(null);
  const [CEZA_HIZMETValue, setCEZA_HIZMETValue] = React.useState(null);
  const [KullaniciNot, setKullaniciNot] = React.useState(null);
  const [BolgeNot, setBolgeNot] = React.useState(null);
  const [bolgeonay, setbolgeonay] = React.useState(null);
  const [dosyadetay, setdosyadetay] = React.useState(false);
  const [toplamtutar, settoplamtutar] = React.useState(null);
  const [fisno, setfisno] = React.useState("");



  useEffect(() => {
    setTarihceData(tarihce);
  }, [tarihce]);

  //"TUTAR":0.00,"TUTAR_GAR_MLZ":0.00,"TUTAR_GAR_ISC":0.00,"TUTAR_MON_MLZ":0.00,"TUTAR_MON_ISC":0.00,"TUTAR_HURDA":0.00,"TUTAR_CEZA":0.00,"TUTAR_NAKLIYE":0.00,"TUTAR_YOL_ODEME":0.00,"TUTAR_CEZA_HIZMET_BEDELI":0.00}]
  //const ite = Children.toArray(items);


  useEffect(() => {
    if (GAR_MLZValue == null) {
      items.map(item => setGAR_MLZValue(item.TUTAR_GAR_MLZ))
    }
    if (GAR_ISCValue == null) {
      items.map(item => setGAR_ISCValue(item.TUTAR_GAR_ISC))
    }
    if (MON_MLZValue == null) {
      items.map(item => setMON_MLZValue(item.TUTAR_MON_MLZ))
    }
    if (MON_ISCValue == null) {
      items.map(item => setMON_ISCValue(item.TUTAR_MON_ISC))
    }
    if (CEZAValue == null) {
      items.map(item => setCEZAValue(item.TUTAR_CEZA))
    }
    if (HURDAValue == null) {
      items.map(item => setHURDAValue(item.TUTAR_HURDA))
    }
    if (YOLValue == null) {
      items.map(item => setYOLValue(item.TUTAR_YOL_ODEME))
    }
    if (NAKLIYEValue == null) {
      items.map(item => setNAKLIYEValue(item.TUTAR_NAKLIYE))
    }
    if (CEZA_HIZMETValue == null) {
      items.map(item => setCEZA_HIZMETValue(item.TUTAR_CEZA_HIZMET_BEDELI))
    }

    settoplamtutar(Number(GAR_MLZValue) + Number(GAR_ISCValue) + Number(MON_MLZValue) + Number(MON_ISCValue) + Number(CEZAValue) + Number(HURDAValue) + Number(YOLValue) + Number(NAKLIYEValue) + Number(CEZA_HIZMETValue));

  }, [GAR_MLZValue, GAR_ISCValue, MON_MLZValue, MON_ISCValue, CEZAValue, HURDAValue, YOLValue, NAKLIYEValue, CEZA_HIZMETValue, items]);


  const setKaynak = event => {
    setKaynakValue(event.target.value);
  };

  const setKonu = event => {
    setKonuValue(event.target.value);
  };

  const setTur = event => {
    setTurValue(event.target.value);
  };

  const setDurum = event => {
    setDurumValue(event.target.value);
  };

  const setSonuc = (event, tip1, tip2) => {
    const sonucdizi = event.target.value.split(',')
    setSonucValue(sonucdizi[0]);

    if (sonucdizi[0] === 107 || sonucdizi[0] === 108) {
      setCEZA_HIZMETValue(tip1);
    }
    else if (sonucdizi[1] === 3 && sonucdizi[0] !== 101 && sonucdizi[0] !== 102) {
      setCEZA_HIZMETValue(tip2);
    }
    else {
      setCEZA_HIZMETValue(0);
    }

  };

  const setTarih = event => {
    setTarihValue(event.target.value);
  };

  const setAciklama = event => {
    setAciklamaValue(event.target.value);
  };

  const setGAR_MLZ = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setGAR_MLZValue(event.target.value);
  };

  const setGAR_ISC = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setGAR_ISCValue(event.target.value);
  };

  const setMON_MLZ = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setMON_MLZValue(event.target.value);
  };

  const setMON_ISC = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setMON_ISCValue(event.target.value);
  };

  const setHURDA = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setHURDAValue(event.target.value);
  };

  const setCEZA = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setCEZAValue(event.target.value);
  };

  const setNAKLIYE = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setNAKLIYEValue(event.target.value);
  };



  const setYOL = event => {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
    setYOLValue(event.target.value);
  };

  const GetNumeric = event => {
    if (event.target.value === '') {
      event.target.value = 0;
    }

  };

  const setNot = event => {
    setKullaniciNot(event.target.value);
  }

  const setBolgeNotu = event => {
    setBolgeNot(event.target.value);
  }

  const setblgonay = (event, tip2) => {
    setbolgeonay(event.target.value);

    if (event.target.value === 2) {
      setCEZA_HIZMETValue(tip2);
    }
    else {
      setCEZA_HIZMETValue(0);
    }

  };

  const getKaynakOptions = () => {
    axios.get('/GetArtemisSondajKaynak/').then((response) => {
      const respons = response.data;
      setKaynakOptions(respons);
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });

  };

  const dosyadetayac = (fis) => {
    setfisno(fis);
    setdosyadetay(true);
  }

  const dosyadetaykapat = () => {
    setdosyadetay(false);
  }

  const getKonuOptions = () => {
    axios.get('/GetArtemisSondajKonu/').then((response) => {
      const respons = response.data;
      setKonuOptions(respons);
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });

  };
  const getTurOptions = () => {
    axios.get('/GetArtemisSondajTur').then((response) => {
      const respons = response.data;
      setTurOptions(respons);
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });

  };
  const getDurumOptions = () => {
    axios.get('/GetArtemisSondajDurum/').then((response) => {
      const respons = response.data;
      setDurumOptions(respons);
    }).catch(error => {
logger.error("Hata detayı:", error.message);
    });

  };
  const getSonucOptions = () => {
    axios.get('/GetArtemisSondajSonuc/').then((response) => {
      const respons = response.data;
      setSonucOptions(respons);
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });

  };




  const KaydetCM = (fis) => {
    const user = getUser();

    Loading = true;
    let ParamsCM = {
      "ReceiptNo": fis.toString(),
      "userid": user.UserId,
      "BOLGE_ACIKLAMA": BolgeNot,
      "BOLGE_ONAY_DRM": bolgeonay,
      "SONUCID": SonucValue,
      "TARIH": TarihValue,
      "GAR_MLZ": GAR_MLZValue ? GAR_MLZValue.toString() : "0",
      "GAR_ISC": GAR_ISCValue ? GAR_ISCValue.toString() : "0",
      "MON_MLZ": MON_MLZValue ? MON_MLZValue.toString() : "0",
      "MON_ISC": MON_ISCValue ? MON_ISCValue.toString() : "0",
      "HURDA": HURDAValue ? HURDAValue.toString() : "0",
      "CEZA": CEZAValue ? CEZAValue.toString() : "0",
      "NAKLIYE": NAKLIYEValue ? NAKLIYEValue.toString() : "0",
      "YOL": YOLValue ? YOLValue.toString() : "0",
      "CEZA_HIZMET": CEZA_HIZMETValue ? CEZA_HIZMETValue.toString() : "0",
      "KULLANICINOT": KullaniciNot
    };

    axios.post('/SetArtemisSondajCM', ParamsCM)
      .then(
        res => {
          const response = res.data.length === 0 ? [] : res.data;
          alert(response.ErrorDescription);
          Loading = false;
          this.forceUpdate();

        }


      )
      .catch(
        err => {
          Loading = false;
          logger.error("Hata detayı:", err.message);
        }

      );

    handleRefreshSondaj();



  };

  const KaydetBolge = (fis, sonuc, durum) => {

    if ((SonucValue === -1) || (SonucValue === null && sonuc === -1)) {
      alert("Sonuç alanı boş bırakılamaz!");
      return;
    }
    if ((DurumValue === -1) || (DurumValue === null && durum === -1)) {
      alert("Durum alanı boş bırakılamaz!");
      return;
    }


    var DurumParam = null;

    if (durum === -100) {
      DurumParam = -100
    } else {
      DurumParam = DurumValue;
    }

    const user = getUser();
    Loading = true;



    let ParamsBLG = {
      "ReceiptNo": fis.toString(),
      "userid": user.UserId,
      "ACIKLAMA": AciklamaValue,
      "KULLANICINOT": KullaniciNot,
      "KAYNAK": KaynakValue || "3",
      "KONU": KonuValue,
      "DURUM": DurumParam,
      "TARIH": TarihValue,
      "SONUCID": SonucValue,
      "GAR_MLZ": GAR_MLZValue ? GAR_MLZValue.toString() : "0",
      "GAR_ISC": GAR_ISCValue ? GAR_ISCValue.toString() : "0",
      "MON_MLZ": MON_MLZValue ? MON_MLZValue.toString() : "0",
      "MON_ISC": MON_ISCValue ? MON_ISCValue.toString() : "0",
      "HURDA": HURDAValue ? HURDAValue.toString() : "0",
      "CEZA": CEZAValue ? CEZAValue.toString() : "0",
      "NAKLIYE": NAKLIYEValue ? NAKLIYEValue.toString() : "0",
      "YOL": YOLValue ? YOLValue.toString() : "0",
      "CEZA_HIZMET": CEZA_HIZMETValue ? CEZA_HIZMETValue.toString() : "0"
    };



    axios.post('/SetArtemisSondajBolge', ParamsBLG)
      .then(
        res => {
          const response = res.data.length === 0 ? [] : res.data;
          alert(response.ErrorDescription);
          Loading = false;

        }
      )
      .catch(
        () => {
          Loading = false;
        }

      );


    handleRefreshSondaj();


  };


  if ((KaynakOptions.length > 0) && (KonuOptions.length > 0) && (TurOptions.length > 0) && (DurumOptions.length > 0) && (SonucOptions.length > 0) && (tarihce != null)) {
    if (tarihce.length > 0) {
      Loading = false;
    }
    else {
      Loading = true;
    }
  }
  else {
    getKaynakOptions();

    getKonuOptions();

    getTurOptions();

    getDurumOptions();

    getSonucOptions();




    Loading = true;
  }


  /*if((GAR_MLZValue.length>0) || (GAR_ISCValue.length>0) || (MON_MLZValue.length>0) || (MON_ISCValue.length >0) || (HURDAValue.length>0) || (CEZAValue.length>0) || (CEZA_HIZMETValue.length>0) || (NAKLIYEValue.length >0) || (YOLValue.length >0) )
  {
   settoplam(GAR_MLZValue+GAR_ISCValue+MON_MLZValue+MON_ISCValue+HURDAValue+CEZAValue+CEZA_HIZMETValue+NAKLIYEValue+YOLValue);
   
  }*/
  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.contentCentral}>
          {items?.map(item =>
            <div className={classes.innerCentral}>
              {Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />

                :
                <Grid container spacing={1}>

                  <Grid item xs={20} sm={20}>
                    <Typography variant="subtitle2" >

                      <b>No: </b>


                      {item.ID}

                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="subtitle2" >

                      <b>Fiş No: </b>


                      {item.FIS_NO}

                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="subtitle2" >

                      <b>İşlem Yapan Birim: </b>


                      {item.BIRIM}

                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-outlined-label"
                      >
                        {'Kaynak'}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        label={'Kaynak'}
                        defaultValue={item.KAYNAK}
                        onChange={setKaynak}
                        disabled={Boolean(item.CM)} >

                        {KaynakOptions.map((menu) => (
                          <option value={menu.value}>{menu.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-outlined-label"

                      >
                        {'Konu'}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        label={'Konu'}
                        defaultValue={item.KONU}
                        onChange={setKonu}
                        disabled={Boolean(item.CM)}  >

                        {KonuOptions.map((menu) => (
                          <option value={menu.value}>{menu.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-outlined-label"

                      >
                        {'Türü'}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        label={'Türü'}
                        defaultValue={item.TURU}
                        onChange={setTur}
                        disabled={1} >

                        {TurOptions.map((menu) => (
                          <option value={menu.value}>{menu.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                    <br />
                    Kaydettikten sonra "yerinde" olacak.
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-outlined-label"

                      >
                        {'Durum'}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        label={'Durum'}
                        defaultValue={item.DURUM}
                        onChange={setDurum}
                        disabled={Boolean(item.CM)}  >

                        {DurumOptions.map((menu) => (
                          <option value={menu.value}>{menu.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-outlined-label"

                      >
                        {'Sonuc'}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        label={'Sonuc'}
                        defaultValue={item.SONUC + ',' + item.USTSONUC}
                        onChange={(event) => setSonuc(event)}
                        disabled={item.CM} >

                        {SonucOptions.map((menu) => (
                          <option value={menu.value + ',' + menu.value2}  >{menu.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="subtitle2" >

                      <b>Tarih: </b>
                      <Input type='date' defaultValue={item.TARIH} onChange={setTarih} disabled={item.CMOLUMLU}></Input>


                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Button
                      variant="contained"
                      color="secondary"
                      type='submit'
                      endIcon={<PermMediaIcon>Save</PermMediaIcon>}
                      onClick={() => dosyadetayac(item.FIS_NO)}
                      disabled={item.CMOLUMLU}
                    >
                      Dosyalar
                    </Button>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <b>Açıklama</b>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>

                      <textarea rows={5}
                        cols={30}
                        fullWidth
                        defaultValue={item.ACIKLAMA}
                        onChange={setAciklama}
                        disabled={item.CM} ></textarea>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>


                  {toplamtutar != null ?
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" >
                        <b>Tutar: </b>
                        {toplamtutar}
                      </Typography>
                    </Grid>
                    :
                    <Grid item xs={6} sm={6}>
                      <Typography variant="subtitle2" >
                        <b>Tutar: </b>
                        {item.TUTAR}
                      </Typography>
                    </Grid>
                  }


                  <Grid item xs={6} sm={6}>


                    {CEZA_HIZMETValue == null ?
                      <Typography variant="subtitle2" >
                        <b>Ceza/Hizmet Bedeli: </b>

                        {item.TUTAR_CEZA_HIZMET_BEDELI}
                      </Typography>
                      :
                      <Typography variant="subtitle2" >
                        <b>Ceza/Hizmet Bedeli: </b>

                        {CEZA_HIZMETValue}
                      </Typography>
                    }

                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Garanti Malzeme: </b>
                      <Input defaultValue={item.TUTAR_GAR_MLZ} onChange={setGAR_MLZ} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Garanti İşçilik: </b>
                      <Input defaultValue={item.TUTAR_GAR_ISC} onChange={setGAR_ISC} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Montaj Malzeme: </b>
                      <Input defaultValue={item.TUTAR_MON_MLZ} onChange={setMON_MLZ} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Montaj İşçilik: </b>
                      <Input defaultValue={item.TUTAR_MON_ISC} onChange={setMON_ISC} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>


                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Hurda Tutar: </b>
                      <Input defaultValue={item.TUTAR_HURDA} onChange={setHURDA} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Nakliye Tutar: </b>
                      <Input defaultValue={item.TUTAR_NAKLIYE} onChange={setNAKLIYE} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Cezalar: </b>
                      <Input defaultValue={item.TUTAR_CEZA} onChange={setCEZA} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="subtitle2" >
                      <b>Yol Ödeme: </b>
                      <Input defaultValue={item.TUTAR_YOL_ODEME} onChange={setYOL} type="number" step="0.001" min="0.00" disabled={item.CMOLUMLU} onBlur={GetNumeric}></Input>
                    </Typography>
                  </Grid>

                  {
                    item.CM ?

                      <Grid item xs={12} sm={12}>
                        <br />
                        <Grid item xs={12} sm={12}>
                          <Divider style={{ backgroundColor: '#FF9800' }} />
                        </Grid>


                        <Grid item xs={12} sm={12}>
                          <div>
                            <p><b>Onay</b></p>

                            <input
                              type='checkbox'
                              defaultValue={item.ONAY_DURUMU}
                              disabled={1}>
                            </input>
                            <Typography variant="subtitle2" >

                              {item.ONAYLAYAN}

                            </Typography>
                          </div>
                        </Grid>



                        <Grid item xs={12} sm={12}>
                          <Divider style={{ backgroundColor: '#FF9800' }} />
                        </Grid>
                        <br />
                        <Grid item xs={12} sm={12}>
                          <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel
                              id="demo-simple-select-outlined-label"

                            >
                              {'Bölge Onay Durumu'}
                            </InputLabel>
                            <Select
                              fullWidth
                              native
                              label={'Bölge Onay Durumu'}
                              defaultValue={item.BOLGE_ONAY_DRM}
                              onChange={(event) => setblgonay(event)}
                              disabled={item.CMOLUMLU} >


                              <option value={1}>Olumlu</option>
                              <option value={2}>Olumsuz</option>
                              <option value={3}>Değerlendirilemiyor</option>
                              <option value={0}>İncelenmekte</option>
                            </Select>
                          </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12} sm={12}>
                          <Divider style={{ backgroundColor: '#FF9800' }} />
                        </Grid>
                        <br />
                        <Grid item xs={12} sm={12}>
                          <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel
                              id="demo-simple-select-outlined-label"

                            >
                              {'Bölge Sondaj Türü'}
                            </InputLabel>
                            <Select
                              fullWidth
                              native
                              label={'Bölge Sondaj Türü'}
                              defaultValue={item.BOLGE_ONAY_TURU}
                              disabled={1} >


                              <option value={1}>Telefonda</option>
                              <option value={2}>Yerinde</option>
                              <option value={3}>Bölgede</option>

                            </Select>
                          </FormControl>
                          <br />
                          Sondaj Türü "Yerinde" olarak değişecektir.
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Divider style={{ backgroundColor: '#FF9800' }} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <b>Bölge Açıklama</b>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <FormControl variant="outlined" className={classes.formControl}>

                            <textarea
                              rows={5}
                              cols={30}
                              fullWidth
                              type="textarea"
                              defaultValue={item.BOLGE_ACIKLAMA}
                              onChange={setBolgeNotu}
                              disabled={item.CMOLUMLU}  ></textarea>
                          </FormControl>
                        </Grid>
                        <br />
                        <Grid item xs={12} sm={12}>
                          <Divider style={{ backgroundColor: '#FF9800' }} />
                        </Grid>

                      </Grid>
                      :
                      <Grid item xs={12} sm={12}>
                        <Divider style={{ backgroundColor: '#FF9800' }} />
                      </Grid>
                  }
                  <Grid item xs={12} sm={12}>
                    <Typography variant="outlined" >
                      <b>Kullanıcı Notu</b>

                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl variant="outlined" className={classes.formControl}>

                      <textarea
                        rows={5}
                        fullWidth
                        cols={30}
                        type="textarea" onChange={setNot} disabled={item.CMOLUMLU}  ></textarea>
                    </FormControl>
                  </Grid>

                  {item.CM ?
                    <Grid item xs={12} sm={12}>

                      <Button
                        variant="contained"
                        color="secondary"
                        type='submit'
                        endIcon={<SaveIcon>Save</SaveIcon>}
                        onClick={() => { KaydetCM(item.FIS_NO) }}
                        disabled={item.CMOLUMLU}
                      >
                        Kaydet
                      </Button>




                    </Grid>
                    :
                    <Grid item xs={12} sm={12}>
                      <Button
                        variant="contained"
                        color="secondary"
                        type='submit'
                        endIcon={<SaveIcon>Save</SaveIcon>}
                        onClick={() => { KaydetBolge(item.FIS_NO, item.SONUC, item.DURUM) }}
                        disabled={item.CMOLUMLU}
                      >
                        Kaydet
                      </Button>
                      {"  "}
                      <Button
                        variant="contained"
                        color="secondary"
                        type='submit'
                        endIcon={<SendIcon>Gonder</SendIcon>}
                        onClick={() => { KaydetBolge(item.FIS_NO, -100, -100) }}
                      >
                        Servİse Gönder
                      </Button>
                    </Grid>
                  }

                  <Grid item xs={12} sm={12}>
                    <Divider style={{ backgroundColor: '#FF9800' }} />
                  </Grid>

                  <Grid item xs={12} sm={12}>

                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>İşlem Yapan</TableCell>
                          <TableCell>Sonuç</TableCell>
                          <TableCell>Tarih</TableCell>
                          <TableCell>Not</TableCell>
                          <TableCell>Kullanıcı Notu</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {TarihceData?.map(item =>

                          <TableRow>
                            <TableCell>{item.KAYDEDEN}</TableCell>
                            <TableCell>{item.SONUC}</TableCell>
                            <TableCell>{item.TARIH}</TableCell>
                            <TableCell>{item.NOTLAR}</TableCell>
                            <TableCell>{item.KULLANICINOT}</TableCell>
                          </TableRow>

                        )}
                      </TableBody>
                    </Table>
                  </Grid>



                </Grid>




              }
            </div>

          )}

        </CardContent>
      </Card>
      <Dialog
        fullScreen={false}
        open={dosyadetay}
        onClose={dosyadetaykapat}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Dosyalar
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <SondajPhoto FisNo={fisno}
              className={classes.CentralPaperControl}
              readonly={true}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>



          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={dosyadetaykapat}  >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}

CentralPaperDetail.propTypes = {
  className: PropTypes.string
};

export default CentralPaperDetail;
